import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { WorkItem } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("WORK_ITEM_MODULE");

export const moduleActions = createDataModuleActions<WorkItem>(actionCreator);
export const getWorkItemTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const workItemActions = {
  ...normalizeActions(moduleActions.data),
};
export const workItemActionCreators = {
  ...moduleActions,
};
